import { render, staticRenderFns } from "./CISynchronizer.vue?vue&type=template&id=2e06a8fe&"
import script from "./CISynchronizer.vue?vue&type=script&lang=js&"
export * from "./CISynchronizer.vue?vue&type=script&lang=js&"
import style0 from "./CISynchronizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports